module.exports = __webpack_public_path__ + "img/congyoubing.b6a5994b.jpeg";